module.exports = __webpack_public_path__ + "wod-sound.mp3?bf6194e076ab4c7e2c9f82cb29515d1a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wod-sound.mp3
// module id = 28
// module chunks = 0